import {field} from "../../stem-core/state/StoreField";
import {EditableObjectStatus, VisibilityStatus} from "./misc/GenericEnums";
import {MoneyObject} from "../../stem-core/localization/Money";
import {apiClient} from "../connection/BlinkApiClient";
import {ShippingPriceEntry} from "./misc/ShippingPrice";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {Merchant} from "./MerchantStore";


@globalStore
export class Product extends BaseStore("Product", {}, MoneyObject) {
    @field("Merchant") merchant: Merchant;
    @field(EditableObjectStatus) status: EditableObjectStatus;
    @field(VisibilityStatus) visibility: VisibilityStatus;
    @field(String) name: string;
    @field(String) description: string;
    @field(String) image: string; // Optional, the URL of the image
    @field(Number) inventorySize: number;
    @field(Boolean) allowMultiplePurchasesPerUser: boolean;
    @field(Boolean) requiresAddress: boolean;

    @field(Object) shippingPrices: any[]; // An array of entries, of which the first matching one is used

    // Return an array of ShippingPrice objects. Will modify the objects inline.
    getShippingPrices(): ShippingPriceEntry[] {
        return ShippingPriceEntry.loadArray(this.shippingPrices, this.currencyId);
    }
}

export async function apiMerchantCreateProduct(request: any): Promise<Product> {
    const response = await apiClient.post("/merchant/create_product", request);
    // TODO @Mihai loadObject without index should probably at least log a warning
    //  if there are multiple objects (or None)
    return Product.loadObject(response);
}

export async function apiMerchantEditProduct(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_product", request, {allowNulls: true});
}
